import { ErrorCode } from '@operations/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getAllErrorDescriptions } from '@tom-ui/utils'

export const useStoppageMessageHandler = () => {
  const { t } = useTranslate()

  const getExceptionMessage = (error: any) => {
    const errorDescriptions = getAllErrorDescriptions(error)

    const errors: string[] = []

    errorDescriptions.forEach(errorDescription => {
      if (errorDescription.code === ErrorCode.EntityNotFound) {
        errors.push(
          t('entityNotFound', '{entity} with Id {id} not found', {
            entity: errorDescription.payload?.name,
            id: errorDescription.payload?.id,
          }),
        )
      } else if (errorDescription.code === ErrorCode.EntityListNotFound) {
        errors.push(
          t('entitiesNotFound', '{entity} with Ids {ids} not found', {
            entity: errorDescription.payload?.name,
            ids: errorDescription.payload?.ids?.join(', '),
          }),
        )
      } else if (errorDescription.code === ErrorCode.InvalidDateRange) {
        errors.push(t('endDateGreaterThanStartDate', 'End date is greater than Start date'))
      } else if (errorDescription.code === ErrorCode.FieldRequired) {
        errors.push(
          t('fieldIsRequired', '{field} is required', {
            field: errorDescription.propertyName,
          }),
        )
      }
    })

    if (errors.length > 0) return errors.join('\n')

    return error?.response?.data?.detail ?? t('failedToSaveStoppage', 'Failed to save stoppage')
  }

  const getSuccessMessage = (isEditMode: boolean) => {
    if (isEditMode) {
      return t('stoppageUpdated', 'Stoppage updated')
    }
    return t('stoppageCreated', 'Stoppage created')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
